const getApiConfig = (state)=>{
    return state.apiConfig;
};

export { getApiConfig };
//# sourceMappingURL=selectors.js.map
